import type { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import React, { useContext } from 'react';
import { ResultContext } from './ResultContext';

interface CircleBackgroundProps {
  width: number | string;
  height: number | string;
  children: React.ReactNode;
  sx?: SxProps;
}

export const CircleBackground = ({ width, height, children, sx = {} }: CircleBackgroundProps) => {
  const context = useContext(ResultContext);
  const placeholderContainer = context?.placeholderContainer;
  return (
    <Box
      sx={{
        width,
        height,
        backgroundColor: placeholderContainer ? 'background.paper' : 'background.default',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        aspectRatio: '1/1',
        ...sx
      }}
    >
      {children}
    </Box>
  );
};
